import React, { CSSProperties, useState } from 'react';
import './button.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';

interface ButtonProps {
    text: string;
    style?: CSSProperties;
    className: string;
    onClick: () => void;
    additionalIcon?: React.ReactNode;
    centeredIcon?: React.ReactNode;
    disabled?: boolean;
    loading?: boolean;
    menu?: React.ReactNode[];
    type: "button" | "submit" | "reset" ;
}

const Button = ({text, centeredIcon, additionalIcon, className, onClick= () => {}, style, disabled = false, loading = false, menu, type = "button" }: ButtonProps) => { 

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: React.MouseEvent) => {
        if (!disabled && !loading) {
            if (menu) {
                setAnchorEl(event.currentTarget);
            } else {
                onClick(event);
            }
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const disabledStyle: CSSProperties = {
        backgroundColor: 'lightgrey',
        color: 'grey',
        cursor: 'not-allowed',
        ...style,
    };

    const useStyles = makeStyles({
        paper: {
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
        },
      });

      const classes = useStyles();


    return (
        <button data-testid={'button-package'} type={type}  style={style}  onClick={handleClick}>
            <div 
                className={`${className} nooco-button`} 
                style={{  display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', ...(disabled || loading ? disabledStyle : {}) }} 
            >
            <div style={{ visibility: loading ? 'hidden' : 'visible', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {additionalIcon || null}
                <span style={{marginLeft: additionalIcon && !centeredIcon ? "14px" : undefined}}> {centeredIcon ? centeredIcon : text} </span>
                {menu && 
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                        {Boolean(anchorEl) ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                    </div>
                }
            </div>
                {loading && 
                    <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <CircularProgress size={20} />
                    </div>
                }
            </div>
            {menu && 
                <Popover
                    classes={{ paper: classes.paper }} 
                    style={{padding:"10px", marginTop: "5px"}}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    {menu.map((item, index) => (
                        <Typography key={index}>{item}</Typography>
                    ))}
                </Popover>
            }
        </button>
    );
}

export default Button;
